import React, { useCallback, useEffect, useMemo, useState } from 'react';
import Observer from 'react-intersection-observer';
import { useDispatch, useSelector } from 'react-redux';
import { getFollowerList } from '../../redux/actions/publicProfile';
import Spinner from '../Spinner';
import FollowerItem from './FollowerItem';

const FollowerList = ({ type, profileId, onClose }) => {
  const dispatch = useDispatch();
  const [inView, setInView] = useState(false);
  const { loading, ...otherState } = useSelector(
    (state) => state.publicProfile
  );
  const listData = useMemo(() => {
    const currentData = otherState[type].data;
    const currentMeta = otherState[type].meta;

    return {
      data: currentData,
      meta: currentMeta,
      completed:
        !loading && currentMeta && currentMeta.page >= currentMeta.totalPages,
    };
  }, [loading, otherState, type]);
  const { data, meta, completed } = listData;

  const fetchData = useCallback(
    async (newPage) => {
      const page = newPage || meta?.page + 1 || 1;
      try {
        await dispatch(getFollowerList(profileId, type, page));
      } catch (err) {}
    },
    [dispatch, profileId, type, meta]
  );

  useEffect(() => {
    fetchData(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (inView && !loading && !completed) {
      fetchData();
    }
  }, [inView, completed, loading, fetchData]);

  return (
    <>
      {data.map((profile, index) => {
        return <FollowerItem {...profile} key={index} onClose={onClose} />;
      })}
      {!completed && (
        <div>
          <Observer onChange={(inView) => setInView(inView)}>
            <Spinner />
          </Observer>
        </div>
      )}
    </>
  );
};

export default FollowerList;
